<template>
  <v-app>
    <vpd-toolbar />
    <main class="app-main">
      <router-view></router-view>
    </main>
    <vpd-cookie-banner @hideCookieBanner="hideCookieBanner" :showBanner="show" />
    <vpd-footer />
  </v-app>
</template>

<script>
import "./_App.scss";
import Vue from 'vue';
import VpdToolbar from "./components/vpd-toolbar/vpd-toolbar.vue";
import VpdFooter from "./components/vpd-footer/vpd-footer.vue"
import vpdCookieBanner from "./components/vpd-cookie-banner/vpd-cookie-banner.vue";
import SocketService from "./services/socket.service.js";

export default {
  name: "App",
  components: { VpdToolbar, VpdFooter, vpdCookieBanner },
  props: ["config"],
  data: () => ({
    show: Vue.cookie.get("accepted") ? false : true,
  }),
  async created() {
    await SocketService.setupSocketConnection();
  },
  methods: {
    hideCookieBanner() {
      this.show = false;
    },
    showCookieBanner() {
      this.show = true;
    }
  },
};
</script>
